import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShopSearchComponent } from './search/shop-search/shop-search.component';
import { DatePickerComponent } from './search/date-picker/date-picker.component';
import { PersonComponent } from './search/person/person.component';
import { PromotionCodeComponent } from './search/promotion-code/promotion-code.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { PoiSearchComponent } from './search/poi-search/poi-search.component';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { HighlightPipe } from './pipes/highlight.pipe';
import { SharedModule } from '../shared.module';
import { IconComponent } from '../icons/icon/icon.component';
import { PlatformassetPipe } from '../../../../projects/platform-manager/src/public_api';
import { CurrencyPipe } from '../../core/pipes/currency.pipe';

const sharedCode = [
  ShopSearchComponent,
  PoiSearchComponent,
  DatePickerComponent,
  PersonComponent,
  PromotionCodeComponent
];

/**
 * used for all shared components on landing pages start/saleslocation/zoomIn/shop
 * DO NOT add components, pipes, etc. that are only used by one or only some of those pages to improve load speed and execution time
 **/
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CoreModule,
    SharedModule,
    RouterModule.forChild([]),
    LocalizeRouterModule.forChild([]),
    IconComponent,
    PlatformassetPipe,
    CurrencyPipe
  ],
  declarations: [...sharedCode, HighlightPipe],
  exports: [...sharedCode, CoreModule]
})
export class LandingPageModule {}
